import React, { Component } from 'react'
import './link-set.scss'

export interface LinkModel {
  text: string
  url: string
}

class LinkSet extends Component {
  props: { links: LinkModel[] }

  render() {
    return (
      <div className={'la-link-set'}>
        {this.props.links.map((link, i) => (
          <a className={'la-link la-link-set__item'} href={link.url} key={i}>
            {link.text}
          </a>
        ))}
      </div>
    )
  }
}

export default LinkSet
